import { FiX } from 'react-icons/fi';
import styles from '../css/DemoToast.module.css'
import { MdOutlineInfo } from "react-icons/md";

export const DemoToast = ({ closeToast }) => {
    return (
    <div role="status" className={styles.banner}>
        <div className = {styles.icon}>
            <MdOutlineInfo />
        </div>
        <div>
            <p className={styles.title}>Demo mode</p>
            <p className={styles.message}>
                Your demo session stays active for one hour before resetting.
            </p>
        </div>
        <button type = "button" onClick={() => closeToast()} aria-label="Dismiss" className={styles.dismissBtn}>
            <FiX/>
        </button>
    </div>
  )
}

export default DemoToast